<div
    mdbModal
    #addPaymentMethodModal="mdbModal"
    id="add-payment-method-modal"
    class="modal fade overflow-y-auto"
    tabindex="-1"
    role="dialog"
    (closed)="hideDialog()"
>
    <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        *ngIf="isReady"
    >
        <div class="modal-content add-payment-method-content">
            <div class="modal-header mt-1" id="add-payment-method-header">
                <div class="pull-left">
                    <h3 id="add-payment-method-header-title" data-test="add-payment-method-header-title">
                        <i class="fa fa-credit-card"></i> Add new payment method
                    </h3>
                </div>
                <button
                    type="button"
                    class="close pull-right close-align modal-close-button"
                    aria-label="Close"
                    (click)="hideDialog()"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="add-payment-method-body">
                <div class="container-fluid">
                    <div class="row" id="add-credit-card-details-row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <p class="h5 text-left py-3 text-muted" data-test="alternate-payment-method-heading">
                                <strong>Credit Card Details</strong><br />
                                <small style="font-style: italic"
                                    >Note: The name on the attached billing address will be used as the cardholder
                                    name.</small
                                >
                            </p>

                            <app-credit-card-form
                                [hideNameField]="true"
                                #creditCardFormComponent
                                data-testid="credit-card-entry-component"
                            ></app-credit-card-form>

                            <div>
                                <mdb-checkbox [(ngModel)]="setAsDefault"> Set as default credit card? </mdb-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="row" id="add-billing-address-row">
                        <div class="col-xs-12">
                            <p class="h5 text-left py-3 text-muted" data-test="alternate-payment-method-heading">
                                <strong>Billing Address</strong>
                            </p>
                        </div>

                        <div class="col-xs-12" *ngIf="!forceNewAddress">
                            <div>
                                <input
                                    mdbInput
                                    class="form-check-input"
                                    type="radio"
                                    id="useExistingBillingAddress-true"
                                    [(ngModel)]="useExistingBillingAddress"
                                    (change)="onUseExistingAddressChanged()"
                                    [value]="true"
                                />
                                <label for="useExistingBillingAddress-true">Use existing billing address</label>
                            </div>
                            <div>
                                <input
                                    mdbInput
                                    class="form-check-input"
                                    type="radio"
                                    id="useExistingBillingAddress-false"
                                    [(ngModel)]="useExistingBillingAddress"
                                    (change)="onUseExistingAddressChanged()"
                                    [value]="false"
                                />
                                <label for="useExistingBillingAddress-false">Create a new billing address</label>
                            </div>
                        </div>

                        <div class="col col-xs-12 pb-4" *ngIf="!forceNewAddress && useExistingBillingAddress">
                            <select
                                class="form-control"
                                [(ngModel)]="existingBillingAddressId"
                                id="existingBillingAddressId"
                            >
                                <option *ngFor="let address of billingAddresses | keyvalue" [ngValue]="address.key">
                                    {{ address.value }}
                                </option>
                            </select>
                        </div>

                        <div class="col col-xs-12" *ngIf="!useExistingBillingAddress">
                            <app-address-edit [address]="billingAddress" [scope]="'billing'" #billingAddressComponent> </app-address-edit>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" id="credit-card-modal-footer">
                    <button type="button" class="btn btn-danger" (click)="hideDialog()" [disabled]="isSaving">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="addPaymentMethod($event)" [disabled]="isSaving">Add</button>
                </div>
            </div>
        </div>
    </div>
</div>
